import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { IconInfoCircle } from '@tabler/icons-react';

interface ConfirmRatePlanChangeModalProps {
    show: boolean;
    onClose: () => void;
    onUseRatePlanPrice: () => void;
    onKeepOriginalPrice: () => void;
    newRatePlanName?: string;
}

// Ditampilkan saat user set/ganti rate plan pada reservasi yang sedang diedit.
// Mencegah harga berubah secara diam-diam (rates di-overwrite otomatis dari harga
// standar rate plan baru) tanpa sepengetahuan user, terutama untuk booking dari
// Channel Manager yang rate-nya awalnya unmapped (rate_plan_id null).
const ConfirmRatePlanChangeModal: React.FC<ConfirmRatePlanChangeModalProps> = ({
    show,
    onClose,
    onUseRatePlanPrice,
    onKeepOriginalPrice,
    newRatePlanName,
}) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Rate Plan Change</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-start">
                    <IconInfoCircle size={24} className="me-2 flex-shrink-0 text-primary" />
                    <p className="mb-0">
                        You selected{newRatePlanName ? <> <strong>{newRatePlanName}</strong></> : ' a new rate plan'}.
                        Do you want to use this rate plan's standard price, or keep the current price for this room?
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="outline-primary" onClick={onKeepOriginalPrice}>
                    Keep Original Price
                </Button>
                <Button variant="primary" onClick={onUseRatePlanPrice}>
                    Use Rate Plan Price
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmRatePlanChangeModal;
